<template>
    <tr class="course__list_table_item">
        <td class="course__list_table_name">{{courseName}}</td>
        <td
            v-if="routeQueryView === 'admin'"
            class="course__list_table_author"
        >{{courseAuthor}}
        </td>
        <td class="course__list_table_duration">{{courseDuration}}</td>
        <td
            v-if="routeQueryView === 'course-creator' || routeQueryView === 'admin'"
            class="course__list_table_labels"
        >
            <component-text-list
                :items="courseLabels"
                :limit-active="true"
            ></component-text-list>
        </td>
        <td class="course__list_table_type">{{courseType}}</td>
        <td
            v-if="routeQueryView === 'course-creator'"
            class="course__list_table_status"
        >
            <component-status :status="courseStatus"></component-status>
        </td>
        <td
            v-if="routeQueryView === 'learner'"
            class="course__list_table_enrolmentstatus"
        >
            <component-status :status="courseEnrolmentStatus"></component-status>
        </td>
        <td class="course__list_table_actions">
            <div class="columns is-vcentered">
                <div class="column"></div>
                <div class="column is-narrow">
                    <component-button
                        :theme="'default'"
                        :to="{ name: routeToCourse.name, params: routeToCourse.params, query: { view: routeQueryView, courseVersionId: routeQueryView === 'admin' ? courseVersionId : undefined, catalogId: routeQueryView === 'admin' ? courseCatalogId : undefined } }"
                        :name="`course-list-table-actions-view-${courseCatalogId || courseId}`"
                    >View
                    </component-button>
                </div>
                <template v-if="routeQueryView === 'course-creator' || routeQueryView === 'admin'">
                    <div class="column is-narrow">
                        <component-button-menu
                            :buttons="buttonMenuItems"
                            @emit-create-new-version="redirectToCreateNewVersion"
                            @emit-edit-catalog-item="redirectToEditCatalogItem"
                            @emit-edit-draft="redirectToEditDraft"
                            @emit-enrol-learners="emitOpenEnrolLearnersPopTable"
                            @emit-withdraw-learners="emitOpenWithdrawLearnersPopTable"
                            @emit-download-course-modules="handleDownloadCourseMultipleModules"
                            @emit-download-course-single-module="handleDownloadCourseSingleModules"
                            @emit-copy-course="emitCopyCourse"
                        ></component-button-menu>
                    </div>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'
import ComponentButtonMenu from '@/components/default/shared/ComponentButtonMenu'
import ComponentTextList from '@/components/default/shared/ComponentTextList'
import ComponentStatus from '@/components/default/shared/ComponentStatus'

export default {
  components: { ComponentStatus, ComponentTextList, ComponentButtonMenu, ComponentButton },
  name: 'course-list-table-item',
  data () {
    return {
      user: new User()
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  computed: {
    routeIsCourseView () {
      return this.$route.name === 'ebs-course-show'
    },
    courseId () {
      let courseId

      switch (this.routeQueryView) {
        case 'course-creator':
          courseId = this.item.id
          break
        case 'admin' :
          courseId = this.item.courseId
          break
        default:
          courseId = this.item.courseId
      }

      return courseId
    },
    courseCatalogId () {
      let courseCatalogId

      switch (this.routeQueryView) {
        case 'course-creator':
          courseCatalogId = undefined
          break
        case 'admin' :
          courseCatalogId = this.item.id
          break
        default:
          courseCatalogId = this.item.id
      }

      return courseCatalogId
    },
    courseDuration () {
      return this.item.duration
    },
    courseAuthor () {
      return this.item.createdByName
    },
    courseLabels () {
      return this.item.labels ? this.item.labels.map(obj => Object.values(obj)[0]) : []
    },
    courseVersionId () {
      return this.item.versionId
    },
    courseLatestCompletion () {
      return this.item.latestCompletion
    },
    courseCatalogAvailableLicences () {
      return this.item.availableLicences
    },
    courseEnrolmentStatus () {
      const latestEnrolmentState = this.item.latestEnrolment ? this.item.latestEnrolment.state : null
      const enrolmentStatus = this.item.enrolmentStatus

      return latestEnrolmentState || enrolmentStatus
    },
    courseStatus () {
      return this.item.draft ? 'draft' : 'active'
    },
    courseName () {
      return this.item.name
    },
    courseType () {
      return this.item.type
    },
    courseNumberOfModules () {
      return this.item.moduleCount
    },
    courseIsDraftVersion () {
      return this.item.draft
    },
    routeQueryView () {
      return this.$route.query.view
    },
    routeToCourse () {
      let name
      let params
      if (this.routeQueryView === 'course-creator' || this.routeQueryView === 'admin') {
        name = 'ebs-course-show'
        params = { id: this.courseId }
      } else {
        name = 'ebs-course-version-show'
        params = { courseId: this.courseId, versionId: this.courseVersionId, courseCatalogId: this.courseCatalogId }
      }
      return { name, params }
    },
    buttonMenuItems () {
      let buttonsArr = []

      if (this.routeQueryView === 'course-creator') {
        if (this.courseIsDraftVersion) {
          buttonsArr.push({
            key: 'edit-draft',
            name: 'Edit draft'
          })
        } else {
          buttonsArr.push({
            key: 'create-new-version',
            name: 'Edit course'
          })
        }
        buttonsArr.push({
          key: 'copy-course',
          name: 'Copy course'
        })
      }

      if (this.routeQueryView === 'admin') {
        buttonsArr.push({
          key: 'edit-catalog-item',
          name: 'Edit course'
        })
        buttonsArr.push({
          key: 'enrol-learners',
          name: 'Enrol learners'
        })
        buttonsArr.push({
          key: 'withdraw-learners',
          name: 'Withdraw learners'
        })
        if (
          this.user.isLearningExperienceAdministrator() &&
            this.user.hasCustomerServices(['ELMS']) &&
            this.courseType
        ) {
          buttonsArr.push({
            key: 'download-course-modules',
            name: 'Download course as modules'
          })
          buttonsArr.push({
            key: 'download-course-single-module',
            name: 'Download course as single module'
          })
        }
      }

      return buttonsArr
    }
  },
  methods: {
    redirectToCreateNewVersion () {
      this.$router.push({ name: 'ebs-course-edit', params: { id: this.courseId }, query: { type: 'new-version' } })
    },
    redirectToEditCatalogItem () {
      this.$router.push({ name: 'ebs-catalog-item-edit-enrolment', params: { courseId: this.courseId, versionId: this.courseVersionId, catalogId: this.courseCatalogId } })
    },
    redirectToEditDraft () {
      this.$router.push({ name: 'ebs-course-edit', params: { id: this.courseId }, query: { type: 'edit-draft' } })
    },
    emitCopyCourse () {
      this.$emit('emit', { message: 'emit-copy-course', value: this.courseId })
    },
    emitOpenEnrolLearnersPopTable () {
      this.$emit('emit', { message: 'emit-open-enrol-learners-pop-table', value: { catalogId: this.courseCatalogId, availableLicences: this.courseCatalogAvailableLicences } })
    },
    emitOpenWithdrawLearnersPopTable () {
      this.$emit('emit', { message: 'emit-open-withdraw-learners-pop-table', value: { catalogId: this.courseCatalogId } })
    },
    handleDownloadCourseMultipleModules () {
      this.$store.dispatch('ebsCatalogItemDownloadMultipleModules', { courseCatalogId: this.courseCatalogId, courseName: this.courseName })
    },
    handleDownloadCourseSingleModules () {
      this.$store.dispatch('ebsCatalogItemDownloadSingleModule', { courseCatalogId: this.courseCatalogId, courseName: this.courseName })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/ebs/courses/courselisttableitem";
</style>
